import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { ModalStyles, applyModalCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-modal',
  host: { '[class]': 'styleClassName()' },
  standalone: true,
})
export class FlxModalStyleDirective {
  componentStyle = input<{ style: ModalStyles }>()
  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyModalCustomStyles(this.componentStyle().style, theme())
      this.styleClassName.set(className)
    })
  }
}
